// extracted by mini-css-extract-plugin
export default {"layout":"MobileLayout_layout__evPey","main":"MobileLayout_main__cDDtO"};